module.exports = __webpack_public_path__ + "45b5da42aeac921e491f8253ff475f58.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-ultralight-italic.eot
// module id = 25
// module chunks = 0